<template>
    <div v-if="flowId && !flow" class="text-center py-10">
        <vx-icon-loading class="w-9 h-9 animate-loading-spin"></vx-icon-loading>
    </div>
    <flow-detail-form v-else :flow="flow"></flow-detail-form>
</template>

<script setup>
import FlowDetailForm from './flow/FlowDetailForm.vue';
import { ref } from 'vue';
import { flowsClient } from '~/services';
import { VxIconLoading } from '@voxie/frontend-components';

const props = defineProps({
    flowId: {
        type: [String, undefined],
        default: undefined,
    },
});

const flow = ref(null);

if (props.flowId) {
    flowsClient.get(Spark.state.currentTeam.id, props.flowId).then((r) => (flow.value = r.data));
}
</script>
